import CommonUiModel from "../../common/commonUiModel";

const isReadOnly = ({ formik, moduleArray }) => {
    return moduleArray.includes(formik.values.Module);
};

const RoleModule = new CommonUiModel({
    title:"Role",
    linkColumn: "RoleId",
    idProperty: 'RoleModuleId',
    permissions: { add: false, edit: true, delete: false },
    formTitle: 'Role - Module',
    gridTitle: 'Role - Module',
    tableName: "Security_RoleModule",
    showHistory: false,
    columns: [
        { field: 'Module', label: 'Name ', width: 150, type: 'string', readOnly: true },
        { field: 'Permission1', label: 'View', width: 150, type: 'boolean' },
        { field: 'Permission2', label: 'Add', width: 100, type: 'boolean', readOnly: (formik) => isReadOnly({ formik, moduleArray: ['EquipmentMaster', 'Lookup', 'ReleaseMgmt', 'Role', 'Country'] }) },
        { field: 'Permission3', label: 'Edit', width: 100, type: 'boolean', readOnly: (formik) => isReadOnly({ formik, moduleArray: ['Lookup'] }) },
        { field: 'Permission4', label: 'Delete', width: 150, type: 'boolean',readOnly: (formik) => isReadOnly({ formik, moduleArray: ['EquipmentMaster', 'Lookup', 'ReleaseMgmt', 'Users', 'Role', 'Country'] }) }
    ]
});

export default RoleModule;